import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'reqReferralForms');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'refferal_forms',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/reqReferralForms.js